import { render, staticRenderFns } from "./IconDuim.vue?vue&type=template&id=1ae44b25"
import script from "./IconDuim.vue?vue&type=script&lang=ts"
export * from "./IconDuim.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports